/**
 * @param {string} matchId
 * @param {number} round_num
 * @return {string}
 */
export default (matchId, round_num) => `${matchId}#${round_num}`
